<template>
  <div class="indexbody">
    <el-container id="main" class="main-container" v-cloak>
      <div>
        <div v-if="!isCollapse" class="logo"></div>
        <div v-else="isCollapse" class="logo mini"></div>
      </div>

      <el-aside
        :mini="!isCollapse"
        class="main-left"
        :width="isCollapse ? '60px' : asideMenuWidth"
      >
        <div class="menu-container">
          <transition name="el-fade-in-linear">
            <dt-menu
              :mini="isCollapse"
              :list-data="listData"
              class="sidebar-nav"
            ></dt-menu>
          </transition>
        </div>
      </el-aside>
      <el-container>
        <el-header
          height="50px"
          class="main-top"
          :style="{ paddingLeft: isCollapse ? '160px' : '0px' }"
        >
          <div class="head-nav">
            <div class="head-nav-left">
              <span>
                {{ adminInfo.company }}
              </span>
            </div>
            <ul class="head-nav-right">
              <li>
                <div class="avatar">
                  <img
                    :src="loadImage(adminInfo.avatar)"
                    v-if="adminInfo.avatar"
                  />
                  <i class="el-icon-user-solid" v-else></i>
                </div>
                <h3>{{ adminInfo.userName }}</h3>
              </li>
              <li>
                <el-dropdown>
                  <span class="el-dropdown-link">
                    <i class="el-icon-more"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" class="menu-dropdown">
                    <el-dropdown-item>
                      <el-link
                        :underline="false"
                        icon="el-icon-house"
                        @click="handleHome"
                      >
                        首页
                      </el-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-link
                        :underline="false"
                        icon="el-icon-monitor"
                        @click="handleCabinet"
                      >
                        设备监控
                      </el-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-link
                        :underline="false"
                        icon="el-icon-lock"
                        @click="handlePassword"
                      >
                        修改密码
                      </el-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-link
                        :underline="false"
                        icon="el-icon-switch-button"
                        @click="handleLogout"
                      >
                        注销登录
                      </el-link>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
            </ul>
          </div>
        </el-header>
        <el-main class="main-right">
          <div
            class="miain_show_hide"
            :style="{ left: isCollapse ? '20px' : '20px' }"
            @click="isCollapse = !isCollapse"
          >
            <i class="el-icon-s-fold" v-if="!isCollapse"></i>
            <i class="el-icon-s-unfold" v-if="isCollapse"></i>
          </div>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
    <el-dialog
      class="confirms"
      title="警告"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span
        >密码过于简单！为了确保账户的安全，请使用更复杂、更安全的密码。建议使用包含大小写字母、数字的密码</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleClose()">取 消</el-button>
        <el-button type="primary" size="mini" @click="apply()"
          >修改密码</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { AxiosAjax, saveCompanyData } from "../js/axios.config";
import "../js/menu.component.js";
import "../assets/styles/icon/iconfont.css";
import "../assets/styles/default/index.css";

export default {
  data() {
    return {
      dialogVisible: false,
      isCollapse: false,
      topMenuIcon: "el-icon-s-fold",
      asideMenuWidth: "220px",
      config: [], //系统设置
      adminInfo: { avatar: "", userName: "", company: "" },
      listData: [],
      companyList: [], //公司列表
      companyId: "",
    };
  },
  destroyed: function () {
    window.onresize = null; //注销window.onresize事件
  },
  mounted() {
    const _this = this;
    _this.initData();
    if (localStorage.getItem("fx_login_simple") == "simple") {
      _this.dialogVisible = true;
    }

    this.companyId =
      localStorage.getItem("fx_login_companyId") != null
        ? localStorage.getItem("fx_login_companyId")
        : "";

    // _this.virtualPowerPlant();
  },
  methods: {
    handleClose() {
      localStorage.setItem("fx_login_simple", "");
      this.dialogVisible = false;
    },
    apply() {
      localStorage.setItem("fx_login_simple", "");
      this.$router.push({ name: "Password" });
      this.dialogVisible = false;
    },
    //加载图片地址
    loadImage: function (src) {
      return baseApi + src;
    },
    initData: function () {
      let _this = this;
      //加载菜单数据
      AxiosAjax({
        // url: '/cabinet/navigation/admin/getList',
        url: "/cabinet/navigation/v2/admin/getList",
        loading: true,
        success: function (res) {
          localStorage.setItem(
            "fx_menu_selected_jurisdiction",
            JSON.stringify(res.data.data)
          );
          if (
            !!!localStorage.getItem("fx_menu_selected_id") ||
            localStorage.getItem("fx_menu_selected_id") == ""
          ) {
            if (res.data.data[0].children[0].id) {
              localStorage.setItem(
                "fx_menu_selected_id",
                res.data.data[0].children[0].id
              );
            }

            _this.$forceUpdate();
          }
          _this.listData = res.data.data;
        },
      });
      _this.adminInfo.company = window.localStorage.getItem("fx_login_company");
      _this.adminInfo.userName =
        window.localStorage.getItem("fx_login_username");
      if (window.localStorage.getItem("fx_login_companyType") == "1") {
        var _companyId = window.localStorage.getItem("fx_login_companyId");
        var _companyFullName = window.localStorage.getItem("fx_login_company");
        _this.companyList.push({
          companyFullName: _companyFullName,
          id: _companyId,
        });
        saveCompanyData(_this.companyList);
      } else {
        //加载公司列表
        AxiosAjax({
          url: "/cabinet/company/page?index=1&size=9000",
          loading: true,
          success: function (res) {
            //console.log(res.data)
            _this.companyList = res.data.data.content;
            saveCompanyData(_this.companyList);
          },
        });
      }
    },
    handleLogout: function () {
      localStorage.removeItem("access_token");
      localStorage.setItem("fx_client_refresh_token", "");
      localStorage.setItem("fx_client_access_token", "");
      localStorage.setItem("fx_menu_selected_id", "");
      localStorage.setItem("fx_menu_selected_jurisdiction", "");
      window.localStorage.removeItem("refresh_token");
      AxiosAjax({
        method: "post",
        url: "/cabinet/auth/logout",
        success: function (res) {
          window.location.href = "/login";
        },
      });
    },
    handleHome: function () {
      this.$router.push({ path: "/" });
    },
    handleCabinet: function () {
      this.isCollapse = true;
      this.$router.push({ path: "/monitor/cabinetList" });
    },
    handlePassword: function () {
      this.$router.push({ path: "/manager/password" });
    },

    //存储虚拟电厂token
    virtualPowerPlant() {
      const token = window.localStorage.getItem("fx_client_access_token");
      // AxiosAjax({
      //   method: "post",
      //   url: "/cabinet/company",
      //   data: token,
      //   loading: true,
      //   power_plant: true,
      //   success: function (res) {
      //     console.log(res.data);
      //   },
      // });
    },
  },
};
</script>
<style>
.location {
  padding-left: 30px !important;
}
.sidebar-nav.mini {
  background: #267cb7;
  width: 50px;
}
.sidebar-nav .list-group {
  padding-top: 20px;
}
.sidebar-nav .list-group .list-wrap > h2 {
  display: none;
}
.head-nav .head-nav-left {
  line-height: 50px;
  padding-left: 10px;
  font-size: 16px;
  color: #555;
}
#main {
  position: relative;
}
#main .miain_show_hide {
  position: absolute;
  left: 20px;
  height: 20px;
  z-index: 90;
  cursor: pointer;
  width: 20px;
  top: 12px;
  background: #fff;
}
#main .miain_show_hide i {
  font-size: 20px;
  color: #555;
  line-height: 20px;
  background: #fff;
}
#main .logo {
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
  z-index: 110;
  display: block;
  height: 50px;
  width: 220px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: url(/static/img/logo-nav.9f5bde5.png) no-repeat center #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/navHeader.vue